<div class="sla-container">
  <div class="sla-header">
    <div>
      <h2><i class="fa-solid fa-stopwatch"></i> SLA Policies</h2>
      <p class="sla-sub">First-response and resolution time targets, matched to tickets by priority. The most specific active policy (by sort order) is applied; an "All" policy is the fallback.</p>
    </div>
    <button class="btn-primary" (click)="startCreate()" *ngIf="!isCreating">
      <i class="fa-solid fa-plus"></i> New Policy
    </button>
  </div>

  <div class="banner banner-error" *ngIf="errorMessage">{{ errorMessage }}</div>
  <div class="banner banner-success" *ngIf="successMessage">{{ successMessage }}</div>

  <!-- Create -->
  <div class="policy-card editing" *ngIf="isCreating">
    <div class="form-grid">
      <label>Name<input type="text" [(ngModel)]="createForm.name" placeholder="e.g. Critical tickets" /></label>
      <label>Priority
        <select [(ngModel)]="createForm.priority">
          <option *ngFor="let p of priorities" [value]="p">{{ p }}</option>
        </select>
      </label>
      <label>First response (min)<input type="number" min="0" [(ngModel)]="createForm.firstResponseMinutes" placeholder="—" /></label>
      <label>Resolution (min)<input type="number" min="0" [(ngModel)]="createForm.resolutionMinutes" placeholder="—" /></label>
      <label>Escalation person
        <select [(ngModel)]="createForm.escalationPersonId">
          <option value="">None</option>
          <option *ngFor="let p of people" [value]="p.ID">{{ personName(p.ID) }}</option>
        </select>
      </label>
      <label>Escalation team
        <select [(ngModel)]="createForm.escalationTeamId">
          <option value="">None</option>
          <option *ngFor="let t of teams" [value]="t.ID">{{ t.Name }}</option>
        </select>
      </label>
      <label>Sort order<input type="number" [(ngModel)]="createForm.sortOrder" /></label>
      <label>Status
        <select [(ngModel)]="createForm.status">
          <option value="Active">Active</option>
          <option value="Inactive">Inactive</option>
        </select>
      </label>
      <label class="checkbox-field">
        <input type="checkbox" [(ngModel)]="createForm.businessHoursOnly" />
        Business hours only
      </label>
    </div>
    <div class="form-actions">
      <button class="btn-primary" (click)="saveCreate()" [disabled]="isSaving">Create</button>
      <button class="btn-ghost" (click)="cancelCreate()">Cancel</button>
    </div>
  </div>

  <div class="sla-loading" *ngIf="isLoading"><i class="fa-solid fa-spinner fa-spin"></i> Loading policies…</div>

  <div class="sla-empty" *ngIf="!isLoading && policies.length === 0 && !isCreating">
    <i class="fa-solid fa-stopwatch"></i>
    <p>No SLA policies yet. Create one to start tracking response and resolution times.</p>
  </div>

  <!-- Policy list -->
  <div class="policy-card" [class.editing]="d.isEditing" *ngFor="let d of policies">
    <!-- Read row -->
    <div class="policy-row" *ngIf="!d.isEditing">
      <div class="policy-main">
        <span class="policy-name">{{ d.policy.Name }}</span>
        <span class="policy-meta">
          <span class="prio-chip prio-{{ d.policy.Priority | lowercase }}">{{ d.policy.Priority }}</span>
          <span class="metric"><i class="fa-solid fa-reply"></i> {{ formatMinutes(d.policy.FirstResponseTargetMinutes) }}</span>
          <span class="metric"><i class="fa-solid fa-flag-checkered"></i> {{ formatMinutes(d.policy.ResolutionTargetMinutes) }}</span>
          <span class="metric" *ngIf="d.policy.EscalationPersonID || d.policy.EscalationTeamID">
            <i class="fa-solid fa-arrow-up-right-dots"></i>
            {{ d.policy.EscalationPersonID ? personName(d.policy.EscalationPersonID) : teamName(d.policy.EscalationTeamID) }}
          </span>
          <span class="metric" *ngIf="d.policy.BusinessHoursOnly" title="Counts business hours only">
            <i class="fa-solid fa-business-time"></i> Business hrs
          </span>
        </span>
      </div>
      <span class="status-chip" [class.inactive]="d.policy.Status !== 'Active'">{{ d.policy.Status }}</span>
      <div class="policy-actions">
        <button class="icon-btn" title="Edit" (click)="startEdit(d)"><i class="fa-solid fa-pen"></i></button>
        <button class="icon-btn danger" title="Delete" (click)="confirmDelete(d)"><i class="fa-solid fa-trash"></i></button>
      </div>
    </div>

    <!-- Edit form -->
    <div *ngIf="d.isEditing">
      <div class="form-grid">
        <label>Name<input type="text" [(ngModel)]="d.form.name" /></label>
        <label>Priority
          <select [(ngModel)]="d.form.priority">
            <option *ngFor="let p of priorities" [value]="p">{{ p }}</option>
          </select>
        </label>
        <label>First response (min)<input type="number" min="0" [(ngModel)]="d.form.firstResponseMinutes" placeholder="—" /></label>
        <label>Resolution (min)<input type="number" min="0" [(ngModel)]="d.form.resolutionMinutes" placeholder="—" /></label>
        <label>Escalation person
          <select [(ngModel)]="d.form.escalationPersonId">
            <option value="">None</option>
            <option *ngFor="let p of people" [value]="p.ID">{{ personName(p.ID) }}</option>
          </select>
        </label>
        <label>Escalation team
          <select [(ngModel)]="d.form.escalationTeamId">
            <option value="">None</option>
            <option *ngFor="let t of teams" [value]="t.ID">{{ t.Name }}</option>
          </select>
        </label>
        <label>Sort order<input type="number" [(ngModel)]="d.form.sortOrder" /></label>
        <label>Status
          <select [(ngModel)]="d.form.status">
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </label>
        <label class="checkbox-field">
          <input type="checkbox" [(ngModel)]="d.form.businessHoursOnly" />
          Business hours only
        </label>
      </div>
      <div class="form-actions">
        <button class="btn-primary" (click)="saveEdit(d)" [disabled]="isSaving">Save</button>
        <button class="btn-ghost" (click)="cancelEdit(d)">Cancel</button>
      </div>
    </div>
  </div>
</div>
